export default {
 mails: [],
 mail_filter: null,
 mailTags: [],
 meta: {},
 mailSearchQuery: '',
 mailFolders: {
  focused: [],
  others: []
 },
 inboxFolderId: null,
 draftFolderId: null,
 spamFolderId: null,
 sentFolderId: null,
 trashFolderId: null,
 mailSkip: 0,
 mailTop: 10,
 mailEnd: false,
 mailLoading: false,
 mailUpdating: false
};
